import React, { createContext, useContext, useEffect, useState } from "react";
import i18n from "i18next";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { getLocale } from "../utils/common";
import { fetchTranslations, fetchTranslationStatus, translationActions } from "../reducers/translationSlice";

interface TranslationContextProps {
  locale: string;
  setLocale: (locale: string) => void;
}

const TranslationContext = createContext<TranslationContextProps | undefined>(undefined);

export const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const initialLocale =
    document.cookie
      .split("; ")
      .find((row) => row.startsWith("INTEGOLF_COURSES_PORTAL_LOCALE="))
      ?.split("=")[1] || i18n.language;
  const [locale, setLocale] = useState<string>(initialLocale);
  const [localeUpdate, setLocaleUpdate] = useState<number>(0);
  const translationData: any = useAppSelector(fetchTranslations);
  const dispatch = useAppDispatch();
  const translationStatus = useAppSelector(fetchTranslationStatus)
  const [loading, setLoading] = useState(true);



  // useEffect(() => {
  //   if (translationData && translationStatus==="success") {
  //     i18n.addResourceBundle(locale, "translation", translationData[getLocale() as any], true, true);
  //     i18n.changeLanguage(locale);
  //     setLocaleUpdate(Math.random()); // Force re-render if needed
  //     dispatch(translationActions.resetTranslations());
  //   }
  // }, [translationStatus, translationData]);

  // useEffect(() => {
  //   const currentLocale = getLocale();
  //   const localeData = translationData?.[currentLocale];


  //   if (localeData && translationStatus === "success") {

  //     i18n.addResourceBundle(locale, "translation", localeData, true, true);
  //     i18n.changeLanguage(locale);
  //     setLocaleUpdate(Math.random());
  //     dispatch(translationActions.resetTranslations());
  //   }
  // }, [translationStatus, translationData]);

  useEffect(() => {
    const localeData = translationData?.[locale];

    if (localeData && translationStatus === "success") {
      i18n.addResourceBundle(locale, "translation", localeData, true, true);
      i18n.changeLanguage(locale);
      setLocaleUpdate(Math.random()); // optional re-render
      dispatch(translationActions.resetTranslations());
      setLoading(false); // ✅ finished
    }
  }, [translationStatus, translationData, locale]);

  useEffect(() => {
    dispatch(translationActions.translationList({ locale, portal: "coursesportal" }))
  }, [locale])

  return (
    //   <TranslationContext.Provider value={{ locale, setLocale }}>
    //   {children}
    // </TranslationContext.Provider>

    <TranslationContext.Provider value={{ locale, setLocale }}>
      {loading ? <></> : children}
    </TranslationContext.Provider>

  );
};

export const useTranslationContext = (): TranslationContextProps => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error("useTranslationContext must be used within a TranslationProvider");
  }
  return context;
};
